<div class="site-container">
  <div class="site-wrapper-w">
    <ng-container
      *ngIf="
        this.casinoCategoriesList?.categoriesList &&
          this.casinoCategoriesList.categoriesList.length > 0 &&
          this.casinoProviderList?.providerList &&
          this.casinoProviderList.providerList.length > 0;
        else casinoLoading
      ">
      <ng-container *ngIf="this._CasinoService.casinoSliderImageList?.sliderBannerList && this._CasinoService.casinoSliderImageList?.sliderBannerList?.length > 0">
        <casino-banner-component [sliderList]="this._CasinoService.casinoSliderImageList"></casino-banner-component>
      </ng-container>
      <ng-container *ngIf="this.mostFavoritesGameList?.gameList && this.mostFavoritesGameList?.gameList.length > 0">
        <slider-component pageName="lobby" [items]="this.mostFavoritesGameList.gameList" [providerName]="'casino.lobby.most_favorites' | translate"></slider-component>
      </ng-container>
      <div class="casino-header">
        <div class="header-menu" [ngClass]="this.isSearchButton ? 'searchActive' : ''">
          <div class="header-menu-item fav" [ngClass]="this.isFavPage && !this.isSearchButton ? 'active-star' : ''" (click)="this.favIsOpenAction()">
            <image-loader-utils url="star" extraClasses="fav-icon"></image-loader-utils>
            <ng-container *ngIf="this._CasinoService.favList && this._CasinoService.favList.length > 0"></ng-container>
            <div class="fav-count">{{ this._CasinoService.favList.length }}</div>
          </div>
          <div
            *ngFor="let menuItem of this.casinoCategoriesList.categoriesList"
            class="header-menu-item"
            [ngClass]="this.casinoCategory === menuItem.categoryId && !this.isSearchButton ? 'active' : ''"
            (click)="this._CasinoService.selectCasinoCategory(menuItem.categoryId)">
            <span>{{ menuItem.categoryTranslateKey | translate }}</span>
          </div>
        </div>
        <div #headerSearch class="header-search">
          <div (click)="this.searchButtonClick()">
            <image-loader-utils url="search-casino" extraClasses="search-svg"></image-loader-utils>
          </div>
          <input #searchInput placeholder="Search" type="text" [formControl]="searchControl" />
          <div (click)="this.closedSearchButtonClick()">
            <image-loader-utils url="close-casino" extraClasses="close-svg"></image-loader-utils>
          </div>
          <div class="input-divider"></div>
        </div>
      </div>
      <div
        #providerMain
        class="provider-main"
        [@openCloseProviderMenuOne]="this.isOpenProviderMenu ? 'open' : 'closed'"
        [@openCloseProviderMenuTwo]="this.isSearchButton ? 'closed' : this.isOpenProviderMenu ? 'open' : 'closedOneColumn'">
        <div class="provider-list">
          <div
            class="provider-main-item"
            *ngFor="let provider of this.casinoProviderList?.providerList; trackBy: trackByProviderId"
            (click)="this._CasinoService.selectCasinoProvider(provider.providerId)"
            [ngClass]="provider.providerId === this.casinoProvider ? 'active' : ''">
            <span>{{ provider.providerName }}</span>
            <span class="provider-main-item-divider">|</span>
            <span>{{ provider.gameCount }}</span>
          </div>
        </div>
        <div class="arrow-container" (click)="this.providerMenuOpenControl()">
          <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (this.isOpenProviderMenu ? '' : 'down')"></image-loader-utils>
        </div>
      </div>
      <ng-container *ngIf="this.isFavPage">
        <casino-image-component [gameTypes]="this.favGameDataList" [isGameListLoading]="this.isFavGameListLoading" [isFav]="this.isFavPage"></casino-image-component>
      </ng-container>
      <ng-container *ngIf="!this.isFavPage">
        <casino-image-component [gameTypes]="this.gameDataList" [isGameListLoading]="this.isGameListLoading" [isFav]="this.isFavPage"></casino-image-component>
      </ng-container>
      <div *ngIf="false" class="casino-scroll-to-top" (click)="this._UiHelper.ScrollToTop()">
        <image-loader-utils url="scroll-to-top" extraClasses="scroll-to-top-svg"></image-loader-utils>
      </div>
    </ng-container>
    <ng-template #casinoLoading>
      <div class="casino-loading">
        <div class="loading-circle"></div>
      </div>
    </ng-template>
  </div>
</div>
<ng-container *ngIf="this.isOpenGameModal">
  <casinoGame-dialog
    [openGameData]="this.openGameDataApi"
    [gameData]="this.openGameData"
    [providerData]="this.gameDataList"
    (closedGameModal)="this.closedGameModal()"
    [openGameId]="this.openGameData.id"></casinoGame-dialog>
</ng-container>
